import { render, staticRenderFns } from "./AcademicList.vue?vue&type=template&id=78fbf254&scoped=true"
import script from "./AcademicList.vue?vue&type=script&lang=js"
export * from "./AcademicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fbf254",
  null
  
)

export default component.exports